import request from './axios'

//  获取用户
export const menuGetUserById =  (params) => {
    return request({
        url: "/menu/getUserById",
        method: "get",
        params,
    })
}
//添加或修改用户
export const menusaveOrUpdateUser =  (params) => {
    return request({
        url: "/menu/saveOrUpdateUser",
        method: "post",
        data:params,
    })
}
//系统数字字典用户树
export const getDictionaryTree = (params) => {
      return request({
        url: `/menu/getDictionaryTree`,
        method: "get",
        params,
      })
    }

// 修改字典
export const menuDictionaryadd = (params) => {
    return request({
      url: `/menu/insertOrUpdateDictionary`,
      method: "post",
      data:params,
    })
  }
  
  // 角色权限列表
  export const menuRolePagedList = (page,pageSize) => {
    return request({
      url: `/menu/rolePage?page=${page}&&pageSize=${pageSize}`,
      method: "get",
    })
  }
  // 角色删除
  export const menuremoveRoleDelete = (params) => {
    return request({
      url: `/menu/removeRole`,
      method: "get",
      params
    })
  }
  //加载菜单权限接口
  export const menuLoadPrivileges = (params) => {
    return request({
      url: `/menu/loadPrivileges`,
      method: "get",
      params
    })
  }
  //查看角色授权用户
  export const menuprivilegesUsers = (params) => {
    return request({
      url: `/menu/privilegesUsers`,
      method: "get",
      params
    })
  }
  //删除角色授权用户
  export const removePrincipalDelet = (params) => {
    return request({
      url: `/menu/removePrincipal`,
      method: "get",
      params
    })
  }
  
  //保存或更新角色权限
  export const savePrivileges = (params) => {
    return request({
      url: `/menu/savePrivileges`,
      method: "post",
      data: params
    })
  }
  //新建授权用户列表加载
  export const loadAllPrivilegesUsers = (params) => {
    return request({
      url: `/menu/loadAllPrivilegesUsers`,
      method: "post",
      data: params
    })
  }
  export const loadAllPrivileges = (params) => {
      return request({
       url: `/menu/loadAllPrivileges`,
       method: "get",
       params
      })
     }


  //新建授权用户列表加载
  export const savePrincipal = (params) => {
    return request({
      url: `/menu/savePrincipal`,
      method: "post",
      data: params
    })
  }
  //删除数字字典
  export const deleteDictionary = (params) => {
    return request({
      url: `/menu/deleteDictionary`,
      method: "get",
       params
    })
  }
  //删除系统用户
  export const deleteUserById = (params) => {
    return request({
      url: `/menu/deleteUserById`,
      method: "get",
      params
    })
  }
  //轨迹查询
  export const deviceFindGuiji = (params) => {
    return request({
      url: `/device/track/find`,
      method: "post",
      data: params
    })
  }

  //监控平台在线人数
  export const deviceFindPeople = (params) => {
    return request({
      url: `/device/findUserKindCount?userId=${params}`,
      method: "get",
    })
  }
  //  查找用户下的终端位置
  export const deviceFindUser = (params) => {
    return request({
      url: `/device/findUserDeviceLocation`,
      method: "get",
      params
    })
  }
  

  //定位信息管理查询
  export const FindGpsInfo = (params) => {
    return request({
      url: `/setSystem/findGpsInfo`,
      method: "post",
      data: params
    })
  }

  //定位信息删除
  export const DeleteGpsInfo = (gpsId) => {
    return request({
      url: `/setSystem/deleteGpsInfo?gpsId=${gpsId}`,
      method: "delete",
      
    })
  }
  //  定位信息管理-修改状态
  export const UpdateGpsInfo = (gpsId,status ) => {
    return request({
      url: `/setSystem/updateGpsInfo?gpsId=${gpsId}&&status=${status}`,
      method: "PUT",
      
    })
  }
  //九学王跳转
  export const jiuxueKing = (params) => {
    return request({
      url: `/jiuXueKing/getH5AppTokenPath`,
      method: "get",
      params
    })
  }
  
